import React from "react";
import { AppLink } from "../ui/link";
import { cn } from "../../lib/utils";

export type DashboardTrailItem = {
  label: string;
  href?: string;
};

export type DashboardPageLayoutProps = {
  title: string;
  subtitle?: React.ReactNode;
  trail?: DashboardTrailItem[];
  headerActions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export const DashboardPageLayout: React.FC<DashboardPageLayoutProps> = ({
  title,
  subtitle,
  trail,
  headerActions,
  children,
  className,
}) => (
  <div className={cn("flex flex-col gap-8", className)}>
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        {trail && trail.length > 0 ? (
          <nav
            aria-label="Breadcrumb"
            className="mb-2 flex flex-wrap items-center gap-1 text-sm text-muted-foreground"
          >
            {trail.map((item, index) => {
              const isLast = index === trail.length - 1;
              return (
                <React.Fragment key={`${item.label}-${index}`}>
                  {index > 0 ? <span aria-hidden="true">/</span> : null}
                  {item.href && !isLast ? (
                    <AppLink
                      to={item.href}
                      className="font-medium text-primary hover:underline"
                    >
                      {item.label}
                    </AppLink>
                  ) : (
                    <span
                      className={
                        isLast ? "font-medium text-foreground" : undefined
                      }
                    >
                      {item.label}
                    </span>
                  )}
                </React.Fragment>
              );
            })}
          </nav>
        ) : null}
        <h1 className="ds-page-title">{title}</h1>
        {subtitle ? <p className="ds-page-subtitle mt-2">{subtitle}</p> : null}
      </div>
      {headerActions && (
        <div className="mt-4 md:mt-0 shrink-0">{headerActions}</div>
      )}
    </div>
    {children}
  </div>
);
